window.addEventListener("DOMContentLoaded", () => {
  window.MinimogEvents.subscribe(
    MinimogTheme.pubSubEvents.openCartDrawer,
    () => {
      const carouselContainer = document.querySelector(".slider-products");
      const carouselItems = Array.from(
        document.querySelectorAll(".slider-product")
      );
      const totalProducts = Object.keys(carouselItems).length;
      const productWidth = carouselItems[1].offsetWidth;
      const nextArrow = document.querySelector(".arrow-right");
      const prevArrow = document.querySelector(".arrow-left");
      let current_Index = 0;
      let prev_Index;

      function slideNext() {
        carouselContainer.classList.add("sliding-animation");
        prev_Index = current_Index;
        current_Index = (current_Index + 1) % totalProducts;
        carouselContainer.style.transform = `translateX(-${productWidth}px)`;
        setTimeout(() => {
          carouselContainer.appendChild(carouselItems[prev_Index]);
          carouselContainer.classList.remove("sliding-animation");
          carouselContainer.style.transform = "";
        }, 500);
      }

      function slidePrev() {
        prev_Index = current_Index;
        current_Index = (current_Index - 1 + totalProducts) % totalProducts;

        // Move Carousel to the left
        carouselContainer.style.transform = `translateX(-${productWidth}px)`;
        carouselContainer.insertBefore(
          carouselItems[current_Index],
          carouselContainer.firstChild
        );

        // start the transition effect, from -px to 0 px.
        setTimeout(() => {
          carouselContainer.style.transform = "";
          carouselContainer.classList.add("sliding-animation");
        }, 10);

        setTimeout(() => {
          carouselContainer.classList.remove("sliding-animation");
        }, 490);
      }

      const interval = setInterval(() => {
        slideNext();
      }, 5000);

      nextArrow.addEventListener("click", () => {
        clearInterval(interval);
        slidePrev();
      });
      prevArrow.addEventListener("click", () => {
        clearInterval(interval);
        slideNext();
      });
    }
  );

  const cartDrawerItems = document.querySelector("[data-minimog-cart-items]");
  const sliderProductForm = document.querySelectorAll("[data-slider-form]");
  sliderProductForm.forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      cartDrawerItems.loading.start();
      const formData = new FormData(e.target).entries();

      let quantity;
      let id;
      for (let [key, val] of formData) {
        if (key === "quantity") {
          quantity = val;
        }
        if (key === "id") {
          id = val;
        }
      }

      const productData = {
        quantity: quantity,
        id: id,
      };
      const requestBody = {
        items: [productData],
      };
      const cartDrawer = document.getElementById("MinimogCartDrawer");

      try {
        const cartResponse = await fetch(
          `${window.Shopify.routes.root}cart/add.js`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          }
        );

        cartDrawer.onCartDrawerUpdate();
        cartDrawerItems.loading.finish();
      } catch (error) {
        console.log(error);
      }
    });
  });
});
